import React from "react";
import ReactDOM from "react-dom/client";
// Import (and thereby initialize) error tracking before the App import so any
// error thrown during module evaluation or first render is captured.
import { Sentry } from "./sentry";

import "./assets/css/input.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { lazyWithRetry } from "./utils/lazyWithRetry";
import { isLiveHost } from "./pages/Live/liveHost";

// live.uncoveringintimacy.com serves this same build but renders only the
// webinar pages, with none of the app's chrome or session handling.
const LiveApp = lazyWithRetry(() => import("./LiveApp"));
const live = isLiveHost();
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");
const root = ReactDOM.createRoot(rootEl);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: 24 }}>
          Something went wrong. <a href="/">Reload</a>
        </div>
      }
    >
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          {live ? (
            <React.Suspense fallback={null}>
              <LiveApp />
            </React.Suspense>
          ) : (
            <App />
          )}
        </QueryClientProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
